var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Subtitle',{staticStyle:{"height":"14%"},attrs:{"subtitle":_vm.rightObj.subTitle}}),_c('Echarts',{ref:"myEchartsRight02",staticStyle:{"height":"81%"},attrs:{"parmas":_vm.rightObj.parmas}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }